//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import Routes from "../../Routes";
import { renderLangString } from "../../languageStrings";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import TYPES from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import Main from "../../components/main/Main";
import ReviewCard from "../../components/display/ReviewCard";
import MainNav from "../../components/navigations/MainNav";
import ToggleLayout from "../../components/layout/ToggleLayout";
import AnimateLayout from "../../components/layout/AnimateLayout";
import Title from "../../components/text/Title";
import ExpandableDivAnimation from "../../components/features/ExpandableDivAnimation";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import ParseHTML from "../../functions/ParseHTML";
import validateData from "../../functions/validateData";

// DATA MODEL
import stageDataModel from "../../data_model/reviewer/stage/stage_data";
import stagesDataModel from "../../data_model/reviewer/dashboard/stages";

function ReviewStage({ match }) {
  const isInitialMount = useRef(false);
  const _id = 354980982420984;
  const dispatch = useDispatch();

  const [counterData, setCounterData] = useState();
  const [allStages, setAllStages] = useState([]);
  const [activeReviewStage, setReviewStageActive] = useState({});
  const reduxState = useSelector(state => state);

  const init = useCallback(() => {
    getMenuData();
    getMainData();
  }, [getMenuData, getMainData]);

  // run once on page load
  useEffect(init, []);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  const getMenuData = () => {
    AJAX()
      .getReviewStages(_id, reduxState)
      .then(res => {
        const isMenuDataValid = validateData(
          "Reviewer > Stage > AJAX().getReviewStages",
          res,
          stagesDataModel
        );
        if (isMenuDataValid) {
          removeUpcomingStages(res.data);
          setAllStages(res.data.stages);
        }
      });
  };

  const getMainData = () => {
    AJAX()
      .getReviewStage(_id, reduxState, match.params.id)
      .then(res => {
        // validate the stage data
        const isStageDataValid = validateData(
          "Reviewer > Stage > AJAX().getReviewStage",
          res,
          stageDataModel
        );

        if (isStageDataValid) {
          setReviewStageActive(res.data.stage);

          dispatch({
            type: TYPES.SET_PAGE_IDS,
            payload: { stage: res.data.stage.id },
          });

          setCounterData({
            active: res.data.stage.in_range == 0 ? true : false,
            end_at: res.data.stage.end_at, //new Date().setSeconds(new Date().getSeconds() + 10), //res.data.stage.end_at,
            start_at: res.data.stage.start_at,
            toWhat: "Something",
          });
        }
      });
  };

  const removeUpcomingStages = stagesData => {
    const stageData = JSON.parse(JSON.stringify(stagesData));
    stageData.stages = stageData.stages.filter(i => i.in_range != "-1");
    return stageData;
  };

  const handleNavItemClick = () => {
    dispatch({ type: TYPES.HIDE_MAIN_MENU_ON_TOP });
  };

  const handleCounterEnd = () => {
    getMainData();
  };

  // run on unmount
  useEffect(() => {
    return () => {
      AJAX().cancelRequest(_id);
    };
  }, [_id]);

  return (
    <NewAppHOC>
      <MainAsideNav>
        <AnimateLayout animate={activeReviewStage && allStages} addClass="__n_bs">
          <ExpandableDivAnimation>
            <Title tagName="h1" className="__c_hh">
              {activeReviewStage.title}
            </Title>

            <ParseHTML html={activeReviewStage.description} />
          </ExpandableDivAnimation>

          {allStages && (
            <MainNav
              clicked={handleNavItemClick}
              validate={["stats"]}
              title={renderLangString({ id: "$_k" })}
              data={allStages}
              linkTo={Routes.reviewerStage().path}
              activeItem={match.params.id}
            />
          )}
          {/* </ErrorHOC> */}
        </AnimateLayout>
      </MainAsideNav>
      <Main counter={counterData} onCounterEnd={handleCounterEnd}>
        <AnimateLayout animate={activeReviewStage}>
          <ToggleLayout id="986436795436" title={activeReviewStage.title}>
            {/* {console.log(activeReviewStage.collections)} */}
            {activeReviewStage.collections &&
              activeReviewStage.collections.map(stage => {
                // set the background color of the collection based on parent status
                stage.in_range = activeReviewStage.in_range;

                return (
                  <ReviewCard
                    popoverStatsFor="collection"
                    key={stage.id}
                    data={stage}
                    hideFooter
                    clickTarget={Routes.reviewerCollection().path}
                  />
                );
              })}
          </ToggleLayout>
        </AnimateLayout>
      </Main>
      <HelperAsideNav />
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(ReviewStage));
